import { render, staticRenderFns } from "./ReceiptView.vue?vue&type=template&id=90a551f2&"
import script from "./ReceiptView.vue?vue&type=script&lang=js&"
export * from "./ReceiptView.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports